import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { Link, useNavigate } from 'react-router-dom'

import { FaPlus } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { FaRegEdit } from "react-icons/fa";


import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'


const CancelPolicy = () => {
    const navigate = useNavigate()
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false);
    const [selecteddata, setSelectedData] = useState(null);



    const fetchData = async () => {
        await getApi(endPoints.getcancelpolicy, {
            setResponse: setData,
            setLoading,
            errorMsg: 'Failed to fetch data!'
        });
    };

    useEffect(() => {
        fetchData();
    }, []);


    const handleDelete = async () => {
        if (!selecteddata) return;

        await deleteApi(endPoints.deletecancelpolicy(selecteddata), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete Cancel Policy!'
        });

        setShowDeleteModal(false);
        setShowSuccessModal(true);
        await fetchData();
        setData(null)
        setTimeout(() => setShowSuccessModal(false), 2000);
    };


    const openDeleteModal = (categoryId) => {
        setSelectedData(categoryId);
        setShowDeleteModal(true);
    };




    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="delete Privacy Policy"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Cancel Policy</h6>
                    </div>
                    {data?.data ?
                        <Link to={`/cancelpolicy/edit/${data?.data?._id}`} className={addjob.link}>
                            <div className={addjob.rightbuttons2} onClick={() => navigate('/termsconditions/add')}>
                                <FaRegEdit color='#FFFFFF' />
                                <p>Edit Cancel Policy</p>
                            </div>
                        </Link>
                        :
                        <div className={addjob.rightbuttons2} onClick={() => navigate('/cancelpolicy/add')}>
                            <FaPlus color='#FFFFFF' />
                            <p>Add New Cancel Policy</p>
                        </div>
                    }
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Cancel Policy</h6>
                            <div className={addjob.tableaction}>
                                <RiDeleteBin6Line size={20} style={{ cursor: "pointer", color: "#d9534f" }} onClick={() => openDeleteModal(data?.data?._id)} />
                            </div>
                        </div>
                        {loading ? (
                            <div className={addjob.loadingnormal}>
                                <img src={img2} alt="Loading" width={100} height={100} />
                            </div>
                        ) : (
                            data?.data?.description ? (
                                <div className={addjob.privacypolicy}>
                                    <p>{data?.data?.description}</p>
                                </div>
                            ) : (
                                <div className={addjob.loadingnormal}>
                                    <p>No data available.</p>
                                </div>
                            )
                        )}

                    </div>
                </div>

            </div>
        </>
    )
}

export default HOC(CancelPolicy)